<template>
    <v-container fluid>
        <div v-if="status==''">
            <v-row>
                <v-col class="text-center">
                    <v-img src="https://www.cawgcap.org/images/pacificregion_400x400.jpeg" style="width: 100px; margin-left: auto; margin-right: auto;"/>
                </v-col>
            </v-row>
            <v-row>
                <v-col class="text-center">
                    <span class="text-h5">Pacific Region<br />Office 365 Account Activation</span>
                </v-col>
            </v-row>
            <v-row>
                <v-col class="subtitle-1">
                    Important Information:

                    Members are encouraged to use the provided Office 365 service to facilitate communication and collaboration within our organization. This new email address and password will allow you to access many websites and services that we use internally almost every day.
                    Our vendor has generously donated this service to the Civil Air Patrol, Pacific Region but requires that you:
              </v-col>
            </v-row>
            <v-row>
                <v-col class="subtitle-2">
                    <ul>
                        <li><i>Actively use the service and login at least once every 30 days</i></li>
                        <li><i>Do not share your account credentials with anyone outside of Civil Air Patrol</i></li>
                        <li><i>If your account is compromised, YOU will scan and remediate any findings discovered on your device as soon as possible</i></li>
                        <li><i>As a member of Civil Air Patrol, you must abide by all regulations including CAPR 120-1 and agree to only use this account for official CAP use and never for personal gain.</i></li>
                    </ul>
                </v-col>
            </v-row>
            <v-row>
                <v-col class="subtitle-2">
                    <span class="subtitle-1">Failure to meet any one of these stipulations will result in your account being deactivated and/or deleted.<br /><br /></span>
                    <v-checkbox v-model="checkbox" hide-details class="ma-0 pa-0 subtitle-2" label="I have read the above information." />
                </v-col>
            </v-row>
            <v-row>
                <v-col class="text-center" >
                    <v-btn v-if="checkbox" class="blue darken-4 mr-3" dark @click="submito365licenserequest()">Activate</v-btn>
                    <v-btn v-if="checkbox" class="blue darken-4" dark @click="status='notaccepted'">Do Not Activate</v-btn>
                </v-col>
            </v-row>
        </div>
        <div v-if="status=='notvalid'" style="margin-left: auto; margin-right: auto;">
            <v-row>
                <v-col class="text-center">
                    <v-img src="https://www.cawgcap.org/images/pacificregion_400x400.jpeg" style="width: 100px; margin-left: auto; margin-right: auto;"/>
                </v-col>
            </v-row>
            <v-row>
                <v-col class="subtitle-1 text-center">
                    Cannot activate this account at this time.<br />Please reach out to your Unit/Group IT Officer for assistance.<br /><br />{{errorMsg}}<br /><br />You can now close this window.
              </v-col>
            </v-row>
        </div>
        <div v-if="status=='submitted'">
            <v-row >
                <v-col class="justify-center">
                    <v-img src="https://www.cawgcap.org/images/pacificregion_400x400.jpeg" style="width: 100px; margin-left: auto; margin-right: auto;"/>
                </v-col>
            </v-row>
            <v-row>
                <v-col class="subtitle-1 text-center">
                    Your account activation has been submitted, please allow up to one (1) hour for account activation to complete before attemtping to login.<br /><br />You can now close this window.
              </v-col>
            </v-row>
        </div>
        <div v-if="status=='notaccepted'">
            <v-row >
                <v-col class="justify-center">
                    <v-img src="https://www.cawgcap.org/images/pacificregion_400x400.jpeg" style="width: 100px; margin-left: auto; margin-right: auto;"/>
                </v-col>
            </v-row>
            <v-row>
                <v-col class="subtitle-1 text-center">
                    You have chosen NOT to activate your account.  You will not be able to participate in using any of the tools that are part of the PCR Office 365 Platform.  If you reconsider you can click the link in the original email again and accept activation.<br /><br />You can now close this window.
              </v-col>
            </v-row>
        </div>
    </v-container>
</template>

<script>
export default {
    name:"o365tos",
    props: ["securestring"],
    data () {
        return {
            decEmailAddress: "",
            decCAPID: "",
            decWing: "",
            checkbox: null,
            status: "",
            submitted: false,
            httpResponse:"",
            notValid: false,
            errorMsg: "",
            notaccepted: false,
        }
    },
    mounted() {
        this.parseSecureString()
    },
    methods: {
        parseSecureString() {

            var output = atob(this.securestring).toString()

            var parts = output.split('~~')

            this.decEmailAddress = parts[0]
            this.decCAPID = parts[1]
            this.decWing = parts[2]

        },
        submito365licenserequest() {

            var obj = {
                emailaddress: this.decEmailAddress,
                capid: this.decCAPID,
                wing: this.decWing
            }

            this.$https.post(this.$vars.BaseUrl + this.$vars.InsertO365LicenseRequest, obj, this.$vars.config)
            .then(response => {
                if(response.data.includes("Error"))
                {
                    this.errorMsg = response.data
                    this.status = 'notvalid'
                }
                else
                {
                    this.status = 'submitted'
                }
            })
            .catch(e => {
                this.status = 'notvalid'
            });
        }
    }
}
</script>